const acmeBasic = {
  xs: 12,
  md: 12,
  lg: 12,
  xl: 6,
};
const acmeStretch = {
  xs: 12,
  md: 12,
  lg: 12,
  xl: 12,
};
export type CardOptionsType =
  | 'netWorth'
  | 'recurring'
  | 'setupChecklist'
  | 'creditScore'
  | 'investmentsAcme'
  | 'investmentsGraph'
  | 'achievements'
  | 'savingsGoals'
  | 'watchList'
  | 'incomeTime'
  | 'spendingTime'
  | 'spendingPlan'
  | 'spendingCats'
  | 'upcomingAcme'
  | 'upcoming'
  | 'flags'
  | 'transactions';

export type CardConfig = {
  defaultOrder?: number;
  xs?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label: string;
  name: CardOptionsType;
  titleNav?: string;
};

export const TAB_NAMES = ['BY_MONTH', 'BY_CATEGORY', 'BY_PAYEE'];
export const BY_MONTH = 0;
export const BY_CATEGORY = 1;
export const BY_PAYEE = 2;

export const overviewLayoutVersion = '1.7';

export const overviewCards: Partial<Record<CardOptionsType, CardConfig>> = {
  // ACME CARDS
  setupChecklist: {
    label: 'Complete your set up',
    name: 'setupChecklist',
    ...acmeBasic,
    defaultOrder: 1,
  },
  netWorth: {
    label: 'Net Worth',
    name: 'netWorth',
    ...acmeStretch,
    titleNav: '/net-worth',
    defaultOrder: 3,
  },
  spendingPlan: {
    label: 'Spending Plan',
    name: 'spendingPlan',
    ...acmeStretch,
    titleNav: '/spending-plan',
    defaultOrder: 4,
  },
  upcomingAcme: {
    label: 'Upcoming',
    name: 'upcomingAcme',
    ...acmeBasic,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 5,
  },
  transactions: {
    label: 'Recent Transactions',
    name: 'transactions',
    ...acmeBasic,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 6,
  },
  spendingCats: {
    label: 'Spending by Category',
    name: 'spendingCats',
    ...acmeBasic,
    titleNav: '/reports/spending/by-category/total',
    defaultOrder: 7,
  },
  savingsGoals: {
    label: 'Savings Goals',
    name: 'savingsGoals',
    ...acmeStretch,
    titleNav: '/goals',
    defaultOrder: 8,
  },
  watchList: {
    label: 'Watchlist',
    name: 'watchList',
    ...acmeStretch,
    titleNav: '/watchlist',
    defaultOrder: 9,
  },
  spendingTime: {
    label: 'Spending Over Time',
    name: 'spendingTime',
    ...acmeBasic,
    titleNav: '/reports/spending/by-none/over-time',
    defaultOrder: 10,
  },
  incomeTime: {
    label: 'Income By Month',
    name: 'incomeTime',
    ...acmeBasic,
    titleNav: '/reports/income/by-none/over-time',
    defaultOrder: 11,
  },
  achievements: {
    label: 'Achievements',
    name: 'achievements',
    ...acmeBasic,
    titleNav: '/achievements',
    defaultOrder: 12,
  },
  investmentsAcme: {
    label: 'Investments',
    name: 'investmentsAcme',
    ...acmeBasic,
    titleNav: '/investing',
    defaultOrder: 13,
  },
  investmentsGraph: {
    label: 'Investments',
    name: 'investmentsGraph',
    ...acmeBasic,
    titleNav: '/investing?selectedTab=balances',
    defaultOrder: 14,
  },
  flags: {
    label: 'Recent Flags',
    name: 'flags',
    ...acmeBasic,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 15,
  },
  creditScore: {
    label: 'Credit Score',
    name: 'creditScore',
    ...acmeBasic,
    defaultOrder: 16,
  },
  recurring: {
    label: 'Recurring',
    name: 'recurring',
    ...acmeBasic,
    defaultOrder: 17,
  },
};

export const overviewLayout = [
  {
    key: 'setupChecklist',
    value: true,
  },
  {
    key: 'netWorth',
    value: true,
  },
  {
    key: 'spendingPlan',
    value: true,
  },
  {
    key: 'transactions',
    value: true,
  },
  {
    key: 'upcomingAcme',
    value: true,
  },
  {
    key: 'recurring',
    value: true,
  },
  {
    key: 'spendingCats',
    value: true,
  },
  {
    key: 'savingsGoals',
    value: true,
  },
  {
    key: 'watchList',
    value: true,
  },
  {
    key: 'spendingTime',
    value: true,
  },
  {
    key: 'incomeTime',
    value: true,
  },
  {
    key: 'achievements',
    value: true,
  },
  {
    key: 'investmentsAcme',
    value: true,
  },
  {
    key: 'investmentsGraph',
    value: true,
  },
  {
    key: 'flags',
    value: true,
  },
  {
    key: 'creditScore',
    value: true,
  },
];
